import './home.scss';
import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Row, Col, Alert, Card, Spinner } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import Stepperform from '../../shared/layout/stepperform/stepperform';
import CaseQuestionaire from '../case-questionaire';
import { getAiChatId } from '../../entities/case-review/case-review.reducer';
import CaseLawyer from '../case-questionaire/case-lawyer';
import { getLawyerAiChatId } from '../../entities/case-forms/case-lawyer.reducer';
import CaseEvidence from '../case-questionaire/case-evidence';
import { CaseReview } from '../../entities/case-review/case-review';

export const Home = () => {
  const { id } = useAppSelector(state => state.authentication?.account);
  const accountdetails = useAppSelector(state => state.authentication.account);
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const get_ai_id: any = localStorage.getItem('ai_id');
  const initalAiId = JSON.parse(get_ai_id);

  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const submissionGuid = params.get('submissionGuid');

    if (submissionGuid) {
      console.log('🔹 HubSpot visitor detected:', submissionGuid);
      sessionStorage.setItem('fromHubspot', 'true');
      sessionStorage.setItem('hubspotSubmissionGuid', submissionGuid);
      if (isAuthenticated) {
        navigate(`/plan?submissionGuid=${submissionGuid}`, { replace: true });
      }
    }
  }, [location.search, isAuthenticated, navigate]);

  useEffect(() => {
    if (accountdetails && typeof accountdetails === 'object' && accountdetails?.activated) {
      const fromHubspot = sessionStorage.getItem('fromHubspot');
      const submissionGuid = sessionStorage.getItem('hubspotSubmissionGuid');

      if (fromHubspot === 'true') {
        sessionStorage.removeItem('fromHubspot');
        navigate(`/plan`, { replace: true });
      } else {
        navigate('/step-1');
      }
    }
  }, [accountdetails, navigate]);

  // useEffect(() => {
  //   if (isAuthenticated == undefined || isAuthenticated?.authentication?.loading == false) {
  //     const port = location.port ? `:${location.port}` : '';
  //     navigate(`${location.hostname}${port}${location.pathname}oauth2/authorization/oidc`);
  //   }
  // }, [isAuthenticated]);

  return (
    <>
      {isAuthenticated && (
        <div className="main-content flex-grow-1 d-flex flex-column gap-5 justify-content-between px-4 pb-4">
          <div className="custom-container flex-grow-1">
            {/* <h1 className="page-title">Case Details Form</h1>
            <Stepperform /> */}
            <Card className="card-wrapper">
              <div className="form-wrapper">
                {/* {(clickedStep == 1 || clickedStep == null) && <CaseQuestionaire handleClicked={handleClicked} />}
                {clickedStep == 2 && <CaseLawyer handleClicked={handleClicked} />}
                {clickedStep == 3 && <CaseEvidence handleClicked={handleClicked} />}
                {clickedStep == 4 && <CaseReview handleClicked={handleClicked} />} */}

                {/* {(entity.step == undefined || data?.step == '1' || entity.step == '1') && <CaseQuestionaire />}
            {entity.step == '2' && 'upcoming next form ......'} */}
              </div>
            </Card>
          </div>

          <div className="footer-sec">
            <p>
              <b className="faq" onClick={() => navigate('/case-faqs')}>
                FAQ
              </b>{' '}
              <b>|</b> <b>Disclaimer:</b> We are not a legal service provider. We connect you to referrals and provide reports and initial
              assessments based on best practices. This does not constitute legal advice. Always consult with legal counsel regarding
              specifics.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
